import React from 'react'

const context = React.createContext({})

export const useHistory = () => {
  const { history } = React.useContext(context)
  return history
}

export const useLocation = () => {
  const { location } = React.useContext(context)
  return location
}

export default context
